module.exports = __webpack_public_path__ + "img/pic1.c486c5d1.png";